export default __webpack_public_path__ + "static/media/forkliftBlue.b297fcfa.svg";